module.exports = __webpack_public_path__ + "media/newstyle/images/3000-outlets-4e865781ee39920d5f9d3d40e401ab18.svg";